import { instance } from "apis/interceptor";

export type TSlackSyncInfo = {
  id: string;
  cratedAt: string;
  updatedAt: string;
  messengerProvider: "SLACK";
  slackWorkspaceId: string;
  slackWorkspaceName: string;
};

//* SLACK 일괄 연동 정보 조회
export const getMemberAuthSyncSlack = async (): Promise<TSlackSyncInfo> => {
  try {
    const result = await instance.get(`/messenger-auto-sync/slack`);
    return result.data as TSlackSyncInfo;
  } catch (e) {
    console.error(e);
    return {} as TSlackSyncInfo;
  }
};

//* SLACK 일괄 연동 자동화
export const syncSlack = async (
  slackWorkspaceId: string,
  slackWorkspaceName: string,
  slackBotToken: string
): Promise<boolean> => {
  try {
    const result = await instance.post(`/messenger-auto-sync/slack`, {
      slackWorkspaceId,
      slackWorkspaceName,
      slackBotToken,
    });

    if (result.status === 201) return true;
    else return false;
  } catch (e) {
    console.error(e);
    return false;
  }
};

//* SLACK 일괄 연동 해제
export const disconnectSlack = async (): Promise<boolean> => {
  try {
    const result = await instance.delete(`/messenger-auto-sync/slack`);

    if (result.status === 200) return true;
    else return false;
  } catch (e) {
    console.error(e);
    return false;
  }
};
